import axios from 'axios';

import { ISubmission } from '../../interfaces/submission';

export type NewSubmissionProps = Omit<ISubmission, '_id' | 'userId' | 'status'>;

const submissionBaseURL = `${process.env.REACT_APP_BASE_API_URL}/submission`;

export const getSingleSubmission = async (accessToken: string | null | undefined, id: string) => {
  const { data: response } = await axios.get(`${submissionBaseURL}/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response;
};

export const createSubmission = async (accessToken: string | null, submission: NewSubmissionProps) => {
  return await axios.post(`${submissionBaseURL}/create`, submission, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
